import apiRequest from '../index'

export default {
  path: '/v1/pitlock/bookingCalendarCalling',
  async get (pitlockStoreId, menuType, startDate, endDate) {
    await window.callNativeHTTPX()
    return apiRequest.get(`${this.path}?store_id=${pitlockStoreId}&menu_type=${menuType}&start_date=${startDate}&end_date=${endDate}`, {
      headers: {
        'HTTP-X-DAPP-REQUESTTIME': window.DAPP_REQUESTTIME,
        'HTTP-X-DAPP-USERID': window.DAPP_USERID,
        'HTTP-X-DAPP-AUTHCD': window.DAPP_AUTHCD
      }
    })
  }
}
